import { connect } from 'react-redux';
import { IVerifyPhoneProps, VerifyPhone } from './VerifyPhone';
import { IAppState } from '../../../common/state';
import {
  verifyPhoneCloseModalAction,
  verifyPhoneShow,
  verifyPhoneErrorMessage,
  verifyPhoneSecondsToRetrySms,
  verifyPhoneSecondsToRetrySmsChangedAction,
  verifyPhoneRequestStartAction,
  verifyPhoneRetrySendingSmsStartAction,
} from '@cian/sms-validation-widget';
import { demandGetRequestedPhone } from '@cian/demand-trap-widget';

type TMapProps = Pick<IVerifyPhoneProps, 'phone' | 'showVerifyPhone' | 'verificationError' | 'secondsToRetrySms'>;

type TActionProps = Pick<IVerifyPhoneProps, 'retrySendingSms' | 'retrySecondsChange' | 'onApprove' | 'onCloseClick'>;

export const mapStateToProps = (state: IAppState): TMapProps => ({
  phone: demandGetRequestedPhone(state),
  showVerifyPhone: verifyPhoneShow(state),
  verificationError: verifyPhoneErrorMessage(state),
  secondsToRetrySms: verifyPhoneSecondsToRetrySms(state),
});

const actions: TActionProps = {
  retrySendingSms: verifyPhoneRetrySendingSmsStartAction,
  retrySecondsChange: verifyPhoneSecondsToRetrySmsChangedAction,
  onApprove: verifyPhoneRequestStartAction,
  onCloseClick: verifyPhoneCloseModalAction,
};

export const VerifyPhoneContainer = connect(mapStateToProps, actions)(VerifyPhone);
